import React, { useRef } from "react";
import { Button, Card, Tabs } from "antd";
import { ProfileTwoTone } from "@ant-design/icons";
import { useModelDispatchers } from "../../../models";
import { CM_ACTION_TYPE, ENV } from "../../../utils/constants";
import AccountList from "./AccountList";
import CustomerForm from "./CustomerForm";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

export default function () {
    const { closeNav } = useModelDispatchers("nav");

    const formRef = useRef();
    const onSave = () => {
        formRef.current.insert();
    }
    const onReset = () => {
        formRef.current.reset();
    }
    const onClose = () => {
        closeNav();
    }

    const Title = () => {
        return (
            <div style={{ display: "flex" }}>
                <h3 style={{ flex: "1" }}>
                    <ProfileTwoTone />
                    <span className="margin-left-8">新增客户</span>
                </h3>
                <div style={{ width: "500px", textAlign: "right" }}>
                    <YhAuth resCode={ResourceAuthEnum.DATA_C_AD_SAVE}>
                        <Button type="primary" onClick={onSave}>保存</Button>
                    </YhAuth>
                    <Button className="margin-left-8" onClick={onReset}>重置</Button>
                    <Button className="margin-left-8" onClick={onClose}>关闭</Button>
                </div>
            </div>
        )
    }
    return (
        <Card
            title={<Title />}
            bordered={true}
            className="margin-top-8"
        >
            <Tabs tabPosition="top">
                <Tabs.TabPane tab="基本信息" key="1">
                    <CustomerForm formRef={formRef} actionType={CM_ACTION_TYPE.INSERT} />
                </Tabs.TabPane>
                <Tabs.TabPane tab="账户信息" key="2" disabled={true}>
                    <AccountList />
                </Tabs.TabPane>

            </Tabs>
        </Card>
    )
};